module.exports = "https://cdn.thelire.com/ins/resource/pic_light@3x.b444fd2ee782c68f42299788c6165eca.png";